import escapeRegex from '../utils/escapeRegex.js';

/**
 * Remove the given needle from the start of string
 *
 * @param string needle
 * @return string
 */
function ltrim(string, needle) {
    if (needle === void 0) { needle = " "; }
    var pattern = "^" + escapeRegex(needle) + "+", regex = new RegExp(pattern, "g");
    return string.replace(regex, "");
}

export { ltrim as default };
